/*======================================================================================================================
  * Bluebell: src/app/state/sandbox/sandbox.selectors.ts
  * Last Edited: 31/07/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSandboxes from './sandbox.reducer';

const selectSandboxesState = createFeatureSelector<fromSandboxes.State>(fromSandboxes.featureKey);

export const selectAllSandboxes = createSelector(
  selectSandboxesState,
  fromSandboxes.getAll
);

export const selectSandboxIds = createSelector(
  selectSandboxesState,
  fromSandboxes.getIds
);

export const selectSandboxCount = createSelector(
  selectSandboxesState,
  fromSandboxes.getCount
);

export const selectSandboxEntities = createSelector(
  selectSandboxesState,
  fromSandboxes.getEntities
);

export const selectSandboxLoading = createSelector(
  selectSandboxesState,
  fromSandboxes.getLoading
);

export const selectSelectedSandboxId = createSelector(
  selectSandboxesState,
  fromSandboxes.getSelectedId
);

/**
 * Complex Selectors
 */

export const selectSelectedSandbox = createSelector(
  selectSandboxesState,
  (state: fromSandboxes.State) => state.selectedId ? (state.entities[state.selectedId] || null) : null
);
